import { render, staticRenderFns } from "./Wp_home_banner_model.vue?vue&type=template&id=5cf1bab5&scoped=true&"
import script from "./Wp_home_banner_model.vue?vue&type=script&lang=js&"
export * from "./Wp_home_banner_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf1bab5",
  null
  
)

export default component.exports